// extracted by mini-css-extract-plugin
export default {"dialogExportButtons":"ExportDialog_dialogExportButtons__9DUaK","tabsHeader":"ExportDialog_tabsHeader__toN-F"};